import {Component, Input} from '@angular/core';
import {DERIVATIVE_BUNDLE_TYPE, EntryGroupService} from '@app/product/services/entry-group.service';
import {DcpEntryGroup, DcpPriceData} from '@dcp/configurator';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {Product, TranslationService} from '@spartacus/core';
import {Observable} from 'rxjs';
import {map, mergeMap} from 'rxjs/operators';
import {AdditionalSolution} from '../additional-required-solutions-modal/additional-required-solutions-modal.component';

@Component({
  selector: 'dcp-additional-required-solution',
  templateUrl: './additional-required-solution.component.html',
  styleUrls: ['./additional-required-solution.component.scss']
})
export class AdditionalRequiredSolutionComponent {
  /** Entry group with displayType is ROOT */
  @Input() additionalSolutions: AdditionalSolution[];
  @Input() headline: string;
  @Input() showToolTipContent: boolean;
  @Input() priceData: DcpPriceData;

  constructor(private entryGroupService: EntryGroupService, private translationService: TranslationService) {
  }

  getProduct(entry: DcpEntryGroup): Product {
    return this.entryGroupService.filterByGroupType(entry.entryGroups)[0]?.entries[0]?.product;
  }

  getDerivatives(entry: DcpEntryGroup): DcpEntryGroup[] {
    return this.entryGroupService.filterByGroupType(entry.entryGroups, DERIVATIVE_BUNDLE_TYPE);
  }

  getToolTipContent(products: OrderEntry[]): Observable<string> {
    return this.translationService.translate('common.braceOpen').pipe(
      mergeMap(bo => this.translationService.translate('common.braceClose').pipe(
        map(bc => products.map(
          p => p.product.name + ' ' + bo + p.product.supplierAlternativeAID + bc).join(', ')
        )
      ))
    );
  }

  getDerivativePrice(derivative: OrderEntry): string {
    if (this.priceData?.price?.componentProducts?.length) {
      return this.priceData.price.componentProducts
        .find(componentProduct => componentProduct.product === derivative.product.supplierAlternativeAID)
        ?.formattedValues.totalValue;
    } else {
      return derivative.totalPrice?.formattedValue;
    }
  }
}
